// extracted by mini-css-extract-plugin
export var active = "header-module--active--e3e28";
export var branding = "header-module--branding--69c35";
export var dHide = "header-module--dHide--ba938";
export var dark = "header-module--dark--2aa0e";
export var description = "header-module--description--607d6";
export var hasChildren = "header-module--hasChildren--db9a1";
export var heading = "header-module--heading--d97a9";
export var icon = "header-module--icon--e370a";
export var inner = "header-module--inner--71ae7";
export var mHide = "header-module--mHide--4080f";
export var main = "header-module--main--56da4";
export var mainCol = "header-module--mainCol--264f7";
export var mainNav = "header-module--mainNav--76169";
export var mainNavBlock = "header-module--mainNavBlock--1a2af";
export var menuToggle = "header-module--menuToggle--4bee3";
export var navWrap = "header-module--navWrap--b78a7";
export var notificationBar = "header-module--notificationBar--58a19";
export var root = "header-module--root--4f83b";
export var sectionHeader = "header-module--sectionHeader--d4913";
export var subMenu = "header-module--subMenu--81d34";
export var utilities = "header-module--utilities--bd52d";